import { AdditionalInfoImpl } from './additional-info-impl';
import { Expose, Type } from 'class-transformer';

export class LedStatus extends AdditionalInfoImpl {
  @Expose({ name: 'actual_brightness' })
  actualBrightness: number;

  @Expose({ name: 'addr_suffix' })
  addrSuffix: number;

  @Expose()
  address: string;

  @Expose({ name: 'light_sensor' })
  lightSensor: number;

  @Expose({ name: 'matrix_state' })
  matrixState: string;

  @Expose({ name: 'panel_size' })
  panelSize: string;

  @Expose({ name: 'supply_state' })
  supplyState: string;

  @Expose({ name: 'supply_voltage' })
  supplyVoltage: number;

  @Expose()
  @Type(() => Date)
  time: Date;

  @Expose()
  version: string;
}
